module.exports = __webpack_public_path__ + "img/7971a3d.svg";